<template>
  <div class="d-flex justify-center align-center wrap flex-column success-page" v-if="render">
    <img src="../../assets/img/confetti.png" class="sp-confetti" />
    <div class="ty-d2d">
      Thank you for booking with us!
    </div>
    <div class="ticket-copy">
      <span>We've sent you an email with the details.</span>
    </div>

    <div class="trip-details-box">
      <div class="td-head">
        <div class="td-field">
          <div>Hotel:</div>
          <b>{{ selected.HotelName }}</b>
        </div>
        <div class="td-field">
          <div>Booking ID:</div>
          <b>{{ commitData.BookingDetails.BookingId }}</b>
        </div>
        <div class="td-field">
          <div>Booking Ref NO:</div>
          <b>{{ commitData.BookingDetails.BookingRefNo }}</b>
        </div>
        <div class="td-field">
          <div>Date:</div>
          <b>{{ dateFormat(hotel.date.start) }}</b>
        </div>
      </div>
    </div>

    <div class="home-link">
      <a href="#" @click="back">Back to Home page</a>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'thankyou-page',
  data () {
    return {
      render: false
    }
  },
  computed: {
    hotel () { return this.$store.state.hotel },
    selected () { return this.hotel.selected },
    blockData () { return this.hotel.block },
    commitData () { return this.hotel.commit }
  },
  methods: {
    back () {
      this.$router.push('/search')
    },
    dateFormat (x) {
      return moment(x, 'MM/DD/YYYY').format('MMM DD YYYY')
    }
  },
  mounted () {
    this.render = false
    if (!this.hotel.view) {
      this.back()
      return
    }
    this.render = true
    this.$store.commit('global/setLoaderData', {show: false})
  }
}
</script>

<style lang="scss" scoped>
.wrap{
  width: 100%;
  min-height: calc(100vh - 20px);
}
.sp-confetti{
  width: 100px;
  transform: rotate(-15deg);
}
.ty-d2d{
  font-size: 24px;
  font-weight: 600;
  line-height: 1.3;
  text-align:center;
  letter-spacing: .8px;
  margin: 10px 0;
}
.ticket-copy{
  font-size:18px;
  letter-spacing: .6px;
  margin-bottom: 30px;
  color: #717e8b;
  width: 500px;
  text-align: center;
}

.trip-details-box{
  border: 1px solid #B3B3B5;
  border-radius: 8px;
  background: #fff;
  width: 500px;
  text-align: center;
}
.td-head{
  padding: 20px 15px;
  letter-spacing: .6px;

  .td-field{
    margin-bottom: 15px;

    &:last-child{
      margin-bottom: 0;
    }
    div{
      font-size: 12px;
      line-height: 1;
      color: #777;
    }
  }
}
.td-body{
  padding: 30px 15px;
  gap: 15px;
  border-top: 1px dashed #6D6D6D;
}
.td-icon{
  font-size: 20px;
}
.td-b-content{
  width: calc(100% - 50px);
}
.td-b-label{
  font-size: 24px;
  line-height: 1;
  font-weight: 600;
  letter-spacing: .6px;
  margin-bottom: 25px;
}
.td-flight, .td-leg{
  font-weight: 600;
  letter-spacing: .6px;
  line-height: 1;
  font-size: 18px;
  gap: 15px;
  margin-bottom: 10px;
}
.td-airline{
  font-size: 14px;
  color: #5E6E7F;
  letter-spacing: .5px;
  div{
    text-transform: capitalize;
    display: inline-block;
  }
  span{
    display: inline-block;
    margin-left: 15px;
  }
}
.td-a-rt{
  margin: 30px 0 10px;
}
.td-leg{
  margin-bottom: 20px;
}
.td-status{
  background: #ecae20;
  font-size: 13px;
  letter-spacing: .6px;
  font-weight: 500;
  padding: 5px 10px;
  color: #fff;
  line-height: 1;
  border-radius: 12px;
  display: inline-block
}
.td-field{
  letter-spacing: .6px;
}
.td-f-label{
  font-size: 12px;
  line-height: 1;
  color: #5E6E7F;
  margin-bottom: 3px;
}
.td-f-value{
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
}
.td-date{
  gap: 40px;
  margin-bottom: 35px;
}

.ground-hr{
  border-bottom: none;
  border-left: none;
  border-right: none;
  border-top: 1px solid #ccc;
  margin-bottom: 45px;
}


.home-link{
  margin: 30px 0;
  font-weight: 600;
  letter-spacing: 1px;

  a{
    color: #cb8112;
  }
}
</style>


// WEBPACK FOOTER //
// thankyou.vue?7e6cd53a